import React from 'react';
import { connect } from 'react-redux';
import { slide as Menu } from 'react-burger-menu'
import './header.css';
import LoginModal from './LoginModal.js'
import LogoutFeedbackModal from './LogoutFeedbackModal.js'
import agent from '../agent';
import { BACKEND_URL } from '../constants/constants';

const mapStateToProps = state => ({
  currentUser: state.common.currentUser,
  profile: state.profile,
});

const mapDispatchToProps = dispatch => ({});

class Header extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      menuOpen: false
    }
    
    this.openLoginModal = this.openLoginModal.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  openLoginModal (event) {
    event.preventDefault()
    this.closeMenu()
    this.refs.modal.openLoginPrompt(this.props.profile.handle)
  }

  handleStateChange (state) {
    this.setState({ menuOpen: state.isOpen })  
  }

  closeMenu () {
    this.setState({ menuOpen: false })
  }

  logout = (event) => {
    if (event) event.preventDefault()
    agent.Profile.logout()
    .then((user) => {
      this.closeMenu()
      this.refs.LogoutFeedbackModal.openLogoutFeedback()
      this.setState({ showError: false });
    })
    .catch(error => {
      this.setState({ showError: true });
    })
  }

  render() {
    return (
      <div>
        <div className="nav-bar-container">
          <div className="empty-div"></div>
          <img src={`${BACKEND_URL}/assets/logo.svg`} width="80px"></img>
          <Menu right disableAutoFocus isOpen={ this.state.menuOpen } onStateChange={ this.handleStateChange }>
            {
              !this.props.currentUser && <a onClick={ this.openLoginModal } className="menu-item" href="">Login</a>
            }
            {
              this.props.currentUser && <a onClick={ this.logout } className="menu-item" href="">Logout</a>
            }
          </Menu>
        </div>
        <LoginModal container={this} ref="modal"/>
        <LogoutFeedbackModal container={this} ref="LogoutFeedbackModal"/>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js